<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a><a id="pvi"></a><a id="pvii"></a><a id="pviii"></a><a id="pix"></a>
<blockquote class="sink">
<p class="right "><em>And so I appeal to our government:</em><br/>
<em>double it, treble it, the guard on this grave.</em></p>
<div class="timebreak "> </div>
<p class="right "><em>—Yevtushenko</em></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?0a5be8bc